import { ReactNode, useEffect } from 'react';
import { useThemeStore } from '@/shared/stores/themeStore';

interface ThemeProviderProps {
  readonly children: ReactNode;
}

export function ThemeProvider({ children }: ThemeProviderProps) {
  const theme = useThemeStore((state) => state.theme);

  useEffect(() => {
    const root = globalThis.document.documentElement;
    root.classList.remove('light', 'dark', 'madivladi');

    if (theme === 'system') {
      const systemTheme = globalThis.matchMedia('(prefers-color-scheme: dark)')
        .matches
        ? 'dark'
        : 'light';
      root.classList.add(systemTheme);
      return;
    }

    // Madi & Vladi theme uses dark background, so add both 'madivladi' and 'dark' classes
    // This allows all existing dark: variants to work automatically
    if (theme === 'madivladi') {
      root.classList.add('madivladi', 'dark');
    } else {
      root.classList.add(theme);
    }
  }, [theme]);

  useEffect(() => {
    const mediaQuery = globalThis.matchMedia('(prefers-color-scheme: dark)');
    const handleChange = () => {
      if (theme === 'system') {
        const root = globalThis.document.documentElement;
        root.classList.remove('light', 'dark', 'madivladi');
        const systemTheme = mediaQuery.matches ? 'dark' : 'light';
        root.classList.add(systemTheme);
      }
    };

    mediaQuery.addEventListener('change', handleChange);
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, [theme]);

  return <>{children}</>;
}
